export class EmployementObjectModel {
    EmploymentObject: any = []
}